import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureTeamListModule } from '../lib/shared-feature-team-list.module'
import { TeamListDocsComponent } from './team-list-docs/team-list-docs.component'
import { TeamListExampleComponent } from './team-list-docs/team-list-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureTeamListModule
  ],
  declarations: [
    TeamListDocsComponent,
    TeamListExampleComponent
  ],
  exports: [
    TeamListDocsComponent
  ]
})
export class SharedFeatureTeamListDocsModule {}
